export const USER_FORM = [
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    label: "Name:",
    required: true,
  },
  {
    name: "contactInfo.phone",
    type: "text",
    placeholder: "Phone Number",
    label: "Phone Number:",
    required: true,
  },
  {
    name: "contactInfo.email",
    type: "email",
    placeholder: "Email Address",
    label: "Email:",
    required: false,
  },
  {
    name: "username",
    type: "text",
    placeholder: "Username",
    label: "Username:",
    required: true,
  },
  {
    name: "licenses",
    type: "number",
    placeholder: "Licenses",
    label: "Licenses:",
    required: true,
  },
];
